export default {"src":"/_next/static/media/all-destinations.bed4659a.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};